import auth from '@/router/auth'
import UserIndex from '@/components/users/Index'
import UserCreate from '@/components/users/Create'
import UserUpdate from '@/components/users/Update'
import UserUpdateTeacher from '@/components/users/UpdateTeacher'
import UserUpdateFilterTeacher from '@/components/users/UpdateFilterTeacher'
import UserShow from '@/components/users/Show'
import UserPush from '@/components/users/PushNoti'

export default [
  {
    path: '/users',
    name: 'users-index',
    component: UserIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users/create',
    name: 'users-create',
    component: UserCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users/update/:id',
    name: 'users-update',
    component: UserUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users/update-teacher/:id',
    name: 'users-update-teacher',
    component: UserUpdateTeacher,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users/update-filter-teacher/:id',
    name: 'users-update-filter-teacher',
    component: UserUpdateFilterTeacher,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users/show/:id',
    name: 'users-show',
    component: UserShow,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users/push/:id',
    name: 'users-push',
    component: UserPush,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/users/router.js